import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './en/translation.json';
import itTranslation from './it/translation.json';
import esTranslation from './es/translation.json';
import frTranslation from './fr/translation.json';
import ptTranslation from './pt/translation.json';
import deTranslation from './de/translation.json';
import nlTranslation from './nl/translation.json';
import plTranslation from './pl/translation.json';
import ruTranslation from './ru/translation.json';

const resources = {
  en: {
    translation: enTranslation,
  },
  it: {
    translation: itTranslation,
  },
  es: {
    translation: esTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  pt: {
    translation: ptTranslation,
  },
  de: {
    translation: deTranslation,
  },
  nl: {
    translation: nlTranslation,
  },
  pl: {
    translation: plTranslation,
  },
  ru: {
    translation: ruTranslation,
  },
};

// Initialize i18n with react-i18next
// CRITICAL: initReactI18next must be called before init()
i18n.use(initReactI18next);

i18n.init({
  resources,
  lng: localStorage.getItem('vitacore_lang') || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
}).then(() => {
  console.log('[I18N] Initialization complete');
}).catch((err) => {
  console.error('[I18N] Initialization error:', err);
});

export default i18n;

